
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex'
import BtnDemo from "@/base-components/BtnDemo.vue";
import InfoBlock from "@/base-components/InfoBlock.vue";
import store from "@/store";

@Options({

  props: {
    isBtnAvalebl:Boolean,
    game:String,
    name:String,
    src: String,
    url: String,
    msg:String,
    AboutUs: String,
    AboutUsText: String,
    OurTeam: String,
    OurTeamText: String,
    OurProduct: String,
    OurProductText: String,
  },
  data() {
    return {
      isIframeVisible: false,
      lockedScrollY: 0
    };
  },
  computed: {
    ...mapGetters(['getJsonData','getUrlInPopUp','getVisibleInPopUp','getGameInPopUp']),
    jsonData() {
      const jsonData = this.getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, "<br>");
      return JSON.parse(jsonDataWithBreaks);
    },
    urlGame() {
      return this.url;
    }
  },
  watch: {
    getVisibleInPopUp(visible: boolean) {
      if (visible) {
        this.lockScroll();
      } else {
        this.unlockScroll();
      }
    },
    getUrlInPopUp(newUrl) {
      const iframe = this.$refs.myIframe as HTMLIFrameElement;
      console.log(newUrl);
      if (iframe && newUrl) {
        iframe.src = '';
        setTimeout(() => {
          document.body.style.overflowY = "hidden";
          iframe.src = newUrl;
        }, 50);
      }
    }
  },
  methods: {
    processName(name:string) {
      return name.replace(/_/g, " ");
    },
    toggleIframe() {
      console.log(this.url)
      this.isIframeVisible = !this.isIframeVisible;
    },
    btnclose(){
      store.commit('setUrlInPopUp', {game:'', url:'',visible:false})
      document.body.style.removeProperty("overflow-y");

      // Немного подождать перед установкой нового значения (обход багов браузера)
      setTimeout(() => {
        document.body.style.overflowY = "scroll";
      }, 10);
    },
    lockScroll() {
      this.lockedScrollY = window.scrollY;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.pointerEvents = 'none';
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    },
    unlockScroll() {
      document.documentElement.style.removeProperty('overflow');
      document.body.style.removeProperty('overflow');
      document.body.style.removeProperty('pointer-events');
      document.body.style.removeProperty('position');
      document.body.style.removeProperty('top');
      document.body.style.removeProperty('left');
      document.body.style.removeProperty('right');
      document.body.style.removeProperty('width');
      window.scrollTo(0, this.lockedScrollY);
    },
    forceReflow() {
      const el = this.$refs.popUp as HTMLElement | undefined;
      if (!el) return;
      el.style.display = 'none';
      void el.offsetHeight;
      el.style.display = '';
    },
    handleOrientationChange() {
      setTimeout(() => this.forceReflow(), 100);
    }
  },

  mounted() {
    window.addEventListener('orientationchange', this.handleOrientationChange);
    window.addEventListener('resize', this.handleOrientationChange);
  },
  beforeUnmount() {
    window.removeEventListener('orientationchange', this.handleOrientationChange);
    window.removeEventListener('resize', this.handleOrientationChange);
  },

  components: {
    BtnDemo,
    InfoBlock
  },
})
export default class GamePopUp extends Vue {
  msg!: string
}
